import { Environment } from '@ld.consumer-portal/models';

export const environment: Environment = {
  production: false,
  appSettings: {
    appName: 'melloServ-web',
    melloServDomainUrl: 'https://ldapi-qa1.loandepotdev.works/MelloServDomain',
    melloServPaymentIntegrationUrl: 'https://ldapi-qa1.loandepotdev.works/paymentintegration',
    bkfsIntegrationUrl: 'https://ldapi-qa1.loandepotdev.works/ServicingLINCPortalBKFSIntegration',
    mlaApiUrl: 'https://ldapi-qa1.loandepotdev.works/mla/',
    cpApiUrl: 'https://ldapi-qa1.loandepotdev.works/cp',
    apiNamespace: 'api/v1',
    servicingCustomerCare: {
      phone: {
        link: 'tel:+18662586572',
        display: '866-258-6572',
      },
    },
    applicationCustomerCare: {
      phone: {
        link: 'tel:+18554143319',
        display: '855-414-3319',
      },
    },
    profileDomainUrl: 'https://ldapi-qa1.loandepotdev.works/ldprofile',
    homeSearchUrl: 'https://loandepot.demo.ch.housecanary.net/homeowner/',
    AppSettings: {
      HelocLoans: '2100000013,2100000021,2100000039,2100000047,2100000054,2100000062',
      enableServisBot: 'true',
    },
    ServicingLINCPortalPayments: 'https://ldapi-qa1.loandepotdev.works/ServicingLINCPortalPayments',
    SEDMDocumentList: 'https://ldapi-qa1.loandepotdev.works/SEDMDocumentListV1',
    SEDMDownloadDocument: 'https://ldapi-qa1.loandepotdev.works/SEDMDownloadDocumentV1',
    SEDMDocumentView: 'https://ldapi-qa1.loandepotdev.works/SEDMDocumentViewV1',
    SEDMMonthRange: 24,
    gtmId: 'GTM-PRR7T7R',
    hostEnv: 'QA1',
    logoutIdleTime: 600,
    logoutCountDownTime: 120,
    ocpApimSubscriptionKey: '',
    cpApimSubscriptionKey: '',
    cpApimSubscriptionKeyCustomerIdentity: '',
    ocpApimSubscriptionSEDM: '',
    ServicingLINCPortalLoans: 'https://ldapi-qa1.loandepotdev.works/ServicingLINCPortalLoans',
    ServicingLINCPortalBorrowers: 'https://ldapi-qa1.loandepotdev.works/ServicingLINCPortalBorrowers',
    LoanConsumerType: '2',
    channelId: '2',
    signUpUrl:
      'https://login-qa1.loandepotdev.works/5fdb02e6-7902-4059-9a90-4f394aec4864/oauth2/v2.0/authorize?p=B2C_1_UNIFIED_SIGNUP&client_id=a3a508f2-420f-4612-b787-8ea1be6ebf8f&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fconsumerportal-qa1.loandepotdev.works%2Fcallback&scope=openid&response_type=id_token&prompt=login',
    oidcSettings: {
      client_id: 'a3a508f2-420f-4612-b787-8ea1be6ebf8f',
      baseUrl: 'https://consumerportal-qa1.loandepotdev.works/',
      redirect_uri: 'https://consumerportal-qa1.loandepotdev.works/callback',
      post_logout_redirect_uri: 'https://consumerportal-qa1.loandepotdev.works/login',
      silent_redirect_uri: 'https://consumerportal-qa1.loandepotdev.works/assets/signin_silent_callback.html',
      signupSigninPolicy: 'b2c_1_unified_signup_signin',
      tenantName: 'MelloB2CDev',
      response_type: 'id_token token',
      loadUserInfo: false,
      response_mode: 'fragment',
      scope: 'https://MelloB2CQA.onmicrosoft.com/consumerportal20/impersonation',
      editProfilePolicy: 'B2C_1_mello_auth_qa1_edit_profile',
      authority:
        'https://login-qa1.loandepotdev.works/tfp/MelloB2CDev.onmicrosoft.com/b2c_1_unified_signup_signin/v2.0/',
      editProfileRouteBase:
        'https://login-qa1.loandepotdev.works/5fdb02e6-7902-4059-9a90-4f394aec4864/oauth2/v2.0/authorize',
      cancellationCode: 'AADB2C90091',
      ropcPolicy: 'B2C_1_loanDepotMobile_Auth',
      ropcSignupPolicy: 'B2C_1_loanDepotMobile_Signup',
      tenantId: '5fdb02e6-7902-4059-9a90-4f394aec4864',
      loginHost: 'login-qa1.loandepotdev.works',
      apiClientId: '6e3e30cb-81a1-4898-b573-5df546bc1afe', // ROPC client ID for QA
      mobileAppId: 'fe8f6a61-a6c6-4be2-b8d0-08028eff2d7a',
    },
    MelloServCRMUrl: 'https://ldapi-qa1.loandepotdev.works/crmintegration/api/v1/MelloServCRMIntegration',
    instrumentationKey: '63bb3129-2249-469a-8a2a-6fbff140c683',
    internalApiKey: '3967bd3a-cf74-4815-83fa-7d4da918c600',
    bannerMessage:
      '[{"messageType":"","bgColor":"#ffffff","textColor":"#2b2a35","body": "<b>Have you or your home been impacted by the disaster?</b> Please contact your insurance company first, and then <a class=\'ms-link font-weight-bold p16\' target=\'_blank\' href=\'/assets/pdf/Disaster Relief Communication_12142021.pdf\'> click here to learn more</a> or call us at <a class=\'ms-link text-nowrap link-phone-number font-weight-bold \' href=\'tel:(866) 258-6572\'>866-258-6572</a>. " ,"startTime": "11/10/21, 02:19 PM","endTime": "01/31/22, 11:59 PM"},{"messageType":"info","bgColor":"#0d6bb8","textColor":"#ffffff","body": "In observance of the holiday, our customer service offices will be closed on Friday, Dec. 24th, Saturday, Dec. 25th, and Friday, Dec. 31st.","startTime": "11/10/21, 02:19 PM","endTime": "12/31/21, 11:59 PM"}]',
    IRS1098MessageExpiry: '{"startTime": "11/10/21, 02:19 PM","endTime": "01/31/22, 11:59 PM"}',
    Mobile_App_Demo: 'https://share.vidyard.com/watch/TuV4dxKgHQM8rVMzdCvvgD?',
    showSaavyCard: 'true',
    showPropertyCard: 'true',
    savvyMoneyPrivacyPolicyLink: 'https://www.savvymoney.com/privacy-policy/',
    comeHomePrivacyPolicyLink: 'https://www.comehome.com/privacy-policy',
    houseCanaryLicenseInfoLink:
      'https://www.housecanary.com/brokerage/?utm_medium=search-results&utm_source=loandepot&utm_campaign=homebuyer',
    helocSiteLink: 'https://www.loandepot.com/heloc',
    iosAppStoreLink: 'https://apps.apple.com/us/app/loandepot-mobile/id1600224229',
    androidPlayStoreLink: 'https://play.google.com/store/apps/details?id=com.loandepot.loandepotmobile&pli=1',
    showPayoffQuoteRequest: 'true',
    enableDefaultPayment: 'true',
    enableSEDM: true,
    SEDMDocumentType: 'IRS 1098,1099 INT,Monthly Billing Statement',
    SEDMMonthlyStatementMonth: 'March',
    servisBot: {
      env: 'stgloandepot',
      endpoint: 'stgloandepot-borrower-bot-qa',
      mobileEndpoint: 'stgloandepot-borrower-bot-mobile-qa',
      envRegion: 'us-1',
      customStyle: 'https://tool-tool-service-bucket.s3.amazonaws.com/loanDepot/style/botStyle_v1.css',
    },

    documents: {
      maxFileSizeInMb: 25,
      allowedExtensions: ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'tiff', 'tif', 'doc', 'docx', 'xls', 'xlsx'],
    },

    originationAuth: {
      loginUrl: 'https://consumerportal-qa1.loandepotdev.works/auth/register',
      dashboardUrl: 'https://servicing-qa1.loandepotdev.works/dashboard',
      updatePasswordUrl:
        'https://login-qa1.loandepotdev.works/5fdb02e6-7902-4059-9a90-4f394aec4864/oauth2/v2.0/authorize?p=B2C_1_UNIFIED_RESET_PASSWORD&client_id=a3a508f2-420f-4612-b787-8ea1be6ebf8f&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fconsumerportal-qa1.loandepotdev.works%2Fcallback&scope=openid&response_type=id_token&prompt=login',
      createPasswordUrl: 'https://login-qa1.loandepotdev.works/create-password',
      sessionExpireWarningInSeconds: 300,
      updatePasswordB2CUrl:
        'https://login-qa1.loandepotdev.works/5fdb02e6-7902-4059-9a90-4f394aec4864/oauth2/v2.0/authorize?p=B2C_1_UNIFIED_RESET_PASSWORD&client_id=a3a508f2-420f-4612-b787-8ea1be6ebf8f&nonce=defaultNonce&redirect_uri=https://servicing-QA1.loandepotdev.works/callback&scope=openid&response_type=id_token&prompt=login',
      updatePasswordCiamUrl:
        'https://consumerportal-qa1.loandepotdev.works/stconsumerportalqa1.onmicrosoft.com/oauth2/v2.0/authorize?scope=openid&response_type=code&redirect_uri=https%3A%2F%2Fconsumerportal-qa1.loandepotdev.works%2Fcallback&prompt=login&acr_values=urn:microsoft:req1',
      logoutB2CUrl: 'https://ldapi-qa1.loandepotdev.works/mla/logout',
    },

    enableScreenshotGallery: true,
    enableOriginationTemplateBuilder: true,
    enableHelocInHousePayment: true,
    enableHelocAutopay: true,

    customerIdentityApiUrl: 'https://ldapi-qa1.loandepotdev.works/customerIdentity',
    customerIdentityDirectApiUrl: 'https://enterprise-customidp.qa1.loandepotdev.io',
    useCustomerIdentityAuth: true,
    useCiamSignup: true,
    ciamDomain: 'consumerportal-qa1.loandepotdev.works',
    ciamTenantHost: 'consumerportal-qa1.loandepotdev.works',
    b2cWebLoginUrl: 'https://consumerportal-qa1.loandepotdev.works/login',
    entraEmailReentryNoticeDurationMs: 10000,

    firebase: {
      apiKey: 'AIzaSyDEYDOp98pfg2XH5r5t6BpQeHgOubR6LxQ',
      authDomain: 'loandepotconsumer-dev-qa-uat.firebaseapp.com',
      projectId: 'loandepotconsumer-dev-qa-uat',
      storageBucket: 'loandepotconsumer-dev-qa-uat.firebasestorage.app',
      messagingSenderId: '1071881500198',
      appId: '1:1071881500198:web:d37c7be81bab81d04058e7',
      measurementId: 'G-QFBG9DFXVE',
    },

    otaUpdateUrl: 'https://stconsumerportalqa1.blob.core.windows.net/ota/latest.json',

    successfulLoginNoteUrl: 'https://ldapi-qa1.loandepotdev.works/ldprofile/api/v1/user/successfulLoginNote',

    mlaWebUrl: 'https://mlaweb-public-qa1.loandepotdev.works',
    mlaPartner: 'loandepot',
    appSource: 'CONSUMER_PORTAL_2',

    dynatrace: {
      enabled: true,
      scriptUrl: 'https://js-cdn.dynatrace.com/jstag/147f273fa2a/bf62026pqf/9c4bf47cbbffa99e_complete.js',
    },

    glance: {
      groupId: '20408',
      site: 'staging',
      ws: 'www.glance.net',
    },
  },
  mockConfig: {
    enabled: false,
    endpoints: {},
  },
};
